import React, { useReducer } from 'react';
import AuthContext from './authContext';
import AuthReducer from './authReducer';

import clienteAxios from '../../service/axios';
import serviceBack from '../../service/serviceBack';

import tokenAuth from '../../service/token';

import { 
    REGISTRO_EXITOSO,
    REGISTRO_ERROR,
    OBTENER_USUARIO,
    PERFIL_OK,
    RECUPERO_CLAVE,
    RECUPERO_OK,
    REESTABLECER_CLAVE,
    ACTUALIZAR_CLAVE,
    LOGIN_EXITOSO,
    LOGIN_ERROR,
    CERRAR_SESION,
    EDITAR_PERFIL
} from 'types/context';

const AuthState = props => {
    const initialState = {
        token: localStorage.getItem('token'),
        autenticado: null,
        usuario: null,        
        cliente: null, // cliente default      
        rol: null, // rol del usuario en el cliente default
        mensaje: null, 
        cargando: true
    }

    const [ state, dispatch ] = useReducer(AuthReducer, initialState);

    const registrarUsuario = async datos => {
        try {

            const respuesta = await clienteAxios.post('/api/usuarios', datos);

            dispatch({
                type: REGISTRO_EXITOSO,
                payload: respuesta.data
            });

            // Obtener el usuario
            usuarioAutenticado();
        } catch (error) {
            // console.log(error.response.data.msg);
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }

            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            })
        }
    }

    // Retorna el usuario autenticado
    const usuarioAutenticado = async () => {
        const token = localStorage.getItem('token');        
        if(token) {
            tokenAuth(token);
            serviceBack.setAuth(token);
        }
        try {
            const respuesta = await clienteAxios.get('/auth');
            dispatch({
                type: OBTENER_USUARIO,
                payload: respuesta.data.usuario
            });
            return respuesta.data
        } catch (error) {
            dispatch({
                type: LOGIN_ERROR
            })
            return error.response
        }
    }

    // Cuando el usuario inicia sesión
    const recuperoClave = async datos => {        
        try {
            const respuesta = await clienteAxios.post('/enviarToken', datos);
            const alerta = {
                msg: "Email enviado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: RECUPERO_OK,
                payload: alerta
            })      
            return respuesta
        } catch (error) {
            //error.response.data.message
            const alerta = {
                msg:  error?.response?.data?.message,
                categoria: 'error'
            }
            dispatch({
                type: LOGIN_ERROR,
                payload: alerta
            })
            return error.response
        }
    }
    
    // Retorna el usuario autenticado
    const reestablecerClave = async (token) => {      
        try {
            const respuesta = await clienteAxios.get(`/validarToken/${token}`);
            dispatch({
                type: REESTABLECER_CLAVE,
                payload: respuesta.data
            });
            return respuesta
        } catch (error) {
            //console.log(error.response);            
            dispatch({
                type: LOGIN_ERROR
            })
            return error.response
        }
        }
    // Retorna el usuario autenticado
    const actualizarClave = async usuario => {
        const {token, password} = usuario;
        try {
            const resultado = await  clienteAxios.put(`/actualizarPassword/`, usuario);
            // Actualizo el usuario en el state
            dispatch({
                type: ACTUALIZAR_CLAVE,
                payload: resultado.data
            });
            const alerta = {
                msg: "Contraseña editada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: PERFIL_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error.response.message,
                categoria: 'error'
            }
            
            dispatch({
                type: LOGIN_ERROR,
                payload: alerta
            })
        }
    }
    // Cuando el usuario inicia sesión
    const iniciarSesion = async datos => {    
        try {
            const respuesta = await clienteAxios.post('/login', datos)
            /* console.log(respuesta.data) */
            dispatch({
                type: LOGIN_EXITOSO,
                payload: respuesta.data.usuario
            });
            // Obtener el usuario           
            usuarioAutenticado();           
        } catch (error) {
            //error.response.data.message
            const alerta = {
                msg:  error.response?.data?.message || "error al iniciar sesión",
                categoria: 'error'
            }

            dispatch({
                type: LOGIN_ERROR,
                payload: alerta
            })
        }
    }

    

    // Cierra la sesión del usuario
    const cerrarSesion = () => {
        localStorage.removeItem('token');
        tokenAuth(null);
        serviceBack.setAuth(null);
        dispatch({
            type: CERRAR_SESION
        })
        // es necesario para que no quede en un loop
        window.location.reload();
    }

    // Editar Perfil Usuario logueado
    const editarPerfil = async usuario => {
        const {email, password} = usuario;
        try {
            const resultado = await  clienteAxios.put(`/usuarios/${usuario.id}`, usuario);
            //console.log(resultado);
            // Actualizo el usuario en el state
            dispatch({
                type: EDITAR_PERFIL,
                payload: resultado.data.usuario
            });
            // reinicio la session para actualizar el token pq puede q cambio el pass
            if ( usuario.password ) {
                await iniciarSesion({ email, password });
            }
            const alerta = {
                msg: "Perfil editado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: PERFIL_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            console.log(error.message)
            const alerta = {
                msg: error.message,
                categoria: 'error'
            }
            
            dispatch({
                type: LOGIN_ERROR,
                payload: alerta
            })
        }
    }

    // Editar Cliente Default Usuario logueado
    const editarClienteDefault = async clienteRol => {
        try {
            const resultado = await  clienteAxios.put(`/usuario/default/clienteRol/`, {clienteRol});
            // actualizo los datos de la session
            dispatch({
                type: OBTENER_USUARIO,
                payload: resultado.data.usuario
            });
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: LOGIN_ERROR,
                payload: alerta
            })
        }
    }

    // Elimino un cliente de la lista del usuario logueado
    const eliminarClienteList = async (idUsuario,clienteRol) => {
        try {
            const resultado = await  clienteAxios.delete(`/usuario/clienteRol/${idUsuario}`,  { data: {clienteRol}});
            // actualizo los datos de la session
            dispatch({
                type: OBTENER_USUARIO,
                payload: resultado.data.usuario
            });
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: LOGIN_ERROR,
                payload: alerta
            })
        }
    }


    // edito el layout del usuario-cliente
    const editarLayout = async (idLayout,layout) => {
        try {
            await  clienteAxios.put(`/layout/${idLayout}`,  { data: {layout}});
            // actualizo los datos de la session
            /*dispatch({
                type: OBTENER_USUARIO,
                payload: resultado.data.usuario
            });*/
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: LOGIN_ERROR,
                payload: alerta
            })
        }
    }
    const okPerfil = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        };            
        dispatch({
            type: PERFIL_OK,
            payload: alerta
        });
    };
    
    // muestra un error de validacion
    const clearOkPerfil = () => {
    dispatch({
        type: PERFIL_OK,
        payload: null,
    });
    };
    
    
        // muestra un error de validacion
        const errorPerfil = (msj,categoria) => {
            const alerta = {
                msg: msj,
                categoria: categoria
            };            
            dispatch({
                type: LOGIN_ERROR,
                payload: alerta
            });
        };
        
        // muestra un error de validacion
        const clearErrorPerfil = () => {
        dispatch({
            type: LOGIN_ERROR,
            payload: null,
        });
    };
    return(
        <AuthContext.Provider
            value={{
                token: state.token,
                autenticado: state.autenticado,
                usuario: state.usuario,
                cliente: state.cliente, 
                rol: state.rol,               
                mensaje: state.mensaje,
                cargando: state.cargando,
                okPerfil,
                clearOkPerfil,
                errorPerfil,
                clearErrorPerfil,
                registrarUsuario,
                iniciarSesion,
                recuperoClave,
                reestablecerClave,
                actualizarClave,
                usuarioAutenticado,
                cerrarSesion,
                editarPerfil,
                editarClienteDefault,
                eliminarClienteList,
                editarLayout
            }}
        >{props.children}

        </AuthContext.Provider>
    )
}
export default AuthState;
